import * as types from "../../ActionType";

const initState = {
    requests: [],
    loadingRequests: true
}

const RequestsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_REQUEST:
            return { ...state, loadingRequests: true }
        case types.GET_REQUESTS:
            return { ...state, requests: action.payload, loadingRequests: false }
        case types.DELETE_REQUEST:
            return { ...state}
        case types.EDIT_REQUEST:
            return { ...state, loadingRequests: true }
        default:
            return state;
    }
};

export default RequestsReducer;

